import React, { Fragment } from 'react'

const ChemicalDosageSearch = () => {
    return (
        <Fragment>
            <div className="row customers ">
                <div className="col-sm-12 laborReport">
                    <h2>Chemicals And Dosages</h2>
                </div>
            </div>
        </Fragment>
    )
}

export default ChemicalDosageSearch
